import { transition } from '@pixelunion/animations';

class NavDesktopDimmer {
  constructor() {
    this.el = document.querySelector('[data-main-nav-dimmer]');
    this.animation = transition({ el: this.el, state: 'closed' });
    this.openers = new Set();
  }

  open(requestor) {
    if (this.openers.has(requestor)) return;
    this.openers.add(requestor);
    this.animation.animateTo('open');
  }

  close(requestor) {
    this.openers.delete(requestor);
    if (this.openers.size) return;
    this.animation.animateTo('closed');
  }

  unload() {
    this.animation.unload();
  }
}

export default new NavDesktopDimmer();
